import { createContext, ReactNode } from "react"

export interface LayoutContextType {
  headerExtra: ReactNode
  setHeaderExtra: (node: ReactNode) => void
}

export const LayoutContext = createContext<LayoutContextType>({
  headerExtra: null,
  setHeaderExtra: () => {},
})
